import CloseIcon from "@mui/icons-material/Close";

import LogoutIcon from "@mui/icons-material/Logout";
import MenuIcon from "@mui/icons-material/Menu";
import { FaSeedling } from "react-icons/fa";
import { GiFarmTractor } from "react-icons/gi";



import TableChartIcon from "@mui/icons-material/TableChart";
import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";

//ICONS-
import { MdDashboard } from "react-icons/md";
import { GiPlantWatering, GiHealthCapsule } from "react-icons/gi";

// import sass file
import "./navbar.scss";
import { removeUserToken } from "../../../utils/auth";

function Navbar() {
  const navigate = useNavigate(); // For navigation after logout

  const [toggle, setToggle] = useState(false);
  const [activeDropdown, setActiveDropdown] = useState(null); // Track active dropdown
  const [selectedItem, setSelectedItem] = useState(null); // Track selected item
  // color state management using react context

  const handleToggle = () => {
    setToggle(!toggle);
    if (!toggle) {
      // Disable body scroll when the toggle is open
      document.body.style.overflow = "hidden";
    } else {
      // Enable body scroll when the toggle is closed
      document.body.style.overflow = "auto";
    }
  };

  // const [isLoggedOut, setIsLoggedOut] = useState(false);

  const handleLogout = async () => {
    try {
      // Remove authentication token
      await removeUserToken();

      // Clear client-side storage
      localStorage.clear();
      sessionStorage.clear();

      // Navigate to the home page
      navigate("/", { replace: true });

      // Reload to ensure a clean slate (only if necessary)
      setTimeout(() => {
        window.location.reload();
      }, 100); // Adding a slight delay to ensure navigation completes first
    } catch (error) {
      console.error("Logout failed:", error);
      // Optionally, show a user-friendly notification
      // showToast("Logout failed. Please try again.");
    }
  };

  const toggleDropdown = (dropdownName) => {
    setActiveDropdown((prev) => (prev === dropdownName ? null : dropdownName));
  };

  const handleItemClick = (item) => {
    setSelectedItem(item);
  };

  return (
    <div className="navbar">
      <div className="navbar_main">
        <div className="menu_logo">
          {toggle ? (
            <CloseIcon className="menu_icon" onClick={handleToggle} />
          ) : (
            <MenuIcon className="menu_icon" onClick={handleToggle} />
          )}

          <Link to="/" style={{ textDecoration: "none" }}>
            <img
              src="/LOGOS/Farmology-Logo-e1687720251448.png"
              alt="Logo"
              className="logo"
            />
          </Link>
        </div>

        <div className="item_lists">
          <div className="item">
            <Link to="/user/profile" style={{ textDecoration: "none" }}>
              <img
                className="admin_pic"
                src="/Images/defaultProfileDp.png"
                alt="admin"
              />
            </Link>
          </div>
        </div>
      </div>

      <div className="res_navbar">
        {toggle && (
          <div className="res_nav_menu">
            <div className="res_nav_menuu">
              <div className="links">
                <ul>
                  <p className="spann">Main</p>
                  <Link to="/user/home" style={{ textDecoration: "none" }}>
                    <li>
                      <MdDashboard className="icon" fontSize="large" /> Home
                    </li>
                  </Link>

                  <p className="spann">Features</p>

                  <Link
                    to="/user/crop-clinic"
                    style={{ textDecoration: "none" }}
                  >
                    <li
                      style={{
                        display: "flex",
                        alignItems: "flex-start",
                        marginTop: "10px", // Adjust the value as needed for top margin
                        marginBottom: "10px", // Adjust the value as needed for bottom margin
                      }}
                    >
                      <GiPlantWatering
                        style={{ fontSize: "20px", marginTop: "0" }}
                        className="icon"
                      />
                      Crop Clinic
                    </li>
                  </Link>
                  <Link
                    to="/user/crop-health-management"
                    style={{ textDecoration: "none" }}
                  >
                    <li
                      style={{
                        display: "flex",
                        alignItems: "flex-start",
                        marginTop: "10px", // Adjust the value as needed for top margin
                        marginBottom: "10px", // Adjust the value as needed for bottom margin
                      }}
                    >
                      <GiFarmTractor
                        style={{ fontSize: "20px", marginTop: "0" }}
                        className="icon"
                      />
                      All Farms
                    </li>
                  </Link>

                  {/* Crop Health Management with Dropdown */}
                  {/* <li
                    className={activeDropdown === "crop-health" ? "active" : ""}
                    onClick={() => toggleDropdown("crop-health")}
                  >
                    <GiHealthCapsule
                      style={{ fontSize: "25px" }}
                      className="icon"
                    />
                    Crop Health Management
                  </li>
                  {activeDropdown === "crop-health" && (
                    <ul className="dropdown">
                      <Link
                        to="/user/crop-health-management"
                        style={{ textDecoration: "none" }}
                      >
                        <li
                          className={
                            selectedItem === "health-monitoring" ? "active" : ""
                          }
                          onClick={() => handleItemClick("health-monitoring")}
                        >
                          Farm List
                        </li>
                      </Link>
                    </ul>
                  )}

                  <Link
                    to="/user/my-subscriptions"
                    style={{ textDecoration: "none" }}
                  >
                    <li
                      style={{
                        display: "flex",
                        alignItems: "flex-start",
                        marginTop: "10px", // Adjust the value as needed for top margin
                        marginBottom: "10px",
                      }}
                    >
                      <TableChartIcon
                        style={{ marginTop: "0", fontSize: "25px" }}
                        className="icon"
                      />{" "}
                      Subscriptions
                    </li>
                  </Link> */}

                  <p className="spann">Seetings</p>
                  <li onClick={handleLogout} style={{ cursor: "pointer" }}>
                    <LogoutIcon className="icon" /> Log Out
                  </li>
                </ul>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default Navbar;
